export default __webpack_public_path__ + "static/media/AdobeStock_157109185.42b8cad2.jpg";